var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 9V18C4 18.5523 4.44772 19 5 19H9.69722C9.89465 19 10.0877 19.0584 10.2519 19.1679L15.6891 22.7927C15.822 22.8813 16 22.786 16 22.6263V19.5C16 19.2239 16.2239 19 16.5 19H19C19.5523 19 20 18.5523 20 18V9", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M2 10L10.971 4.6174C11.6044 4.23738 12.3956 4.23738 13.029 4.61739L22 10", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("circle", { cx: "8", cy: "13", r: "1", fill: "#303030" }),
    React.createElement("circle", { cx: "12", cy: "13", r: "1", fill: "#303030" }),
    React.createElement("circle", { cx: "16", cy: "13", r: "1", fill: "#303030" })
  );
});